import { BaseCartItem, CartBase } from './shopifyTypes'
import { maybe } from './util'

export function getCartSubscriptions(cart: CartBase) {
  return maybe(
    () => cart.items.map((i: BaseCartItem) => maybe(() => i.selling_plan_allocation!.selling_plan.name.toLowerCase())!)
      .filter((x) => !!x), [])!
}
